import { useEffect, useState } from 'react';
import { isAllowedAiImageExtension } from '@/shared/features/ai-quiz-generation/consts';
import { imageDetailModal } from '@/shared/modals/ImageDetailModal';
import { getAiBuilderFileExtension } from '../stores/aiBuilderAttachments';
import { type AiBuilderChatCopy } from '../utils/aiBuilderChatCopy';
import { AiBuilderAttachmentExtensionIcon } from './AiBuilderAttachmentExtensionIcon';
import { AiBuilderAttachmentPreviewCard } from './AiBuilderAttachmentPreviewCard';
type AiBuilderFilePreviewCardProps = {
  copy: AiBuilderChatCopy['attachmentPreview'];
  file: File;
  onRemove?: () => void;
  size: 'composer' | 'message';
};
export const AiBuilderFilePreviewCard = ({
  copy,
  file,
  onRemove,
  size
}: AiBuilderFilePreviewCardProps) => {
  const extension = getAiBuilderFileExtension(file.name);
  const isImage = isAllowedAiImageExtension(extension);
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  useEffect(() => {
    if (!isImage) {
      setImageSrc(null);
      return;
    }
    const objectUrl = URL.createObjectURL(file);
    setImageSrc(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file, isImage]);
  const badge = extension?.toUpperCase() || 'FILE';
  return <AiBuilderAttachmentPreviewCard badge={badge} badgeIcon={<AiBuilderAttachmentExtensionIcon extension={extension} className="size-3" />} loading={isImage && !imageSrc} {...imageSrc ? {
    onPreview: () => imageDetailModal.open(imageSrc),
    previewAriaLabel: copy.imagePreview(file.name)
  } : {}} {...onRemove ? {
    onRemove,
    removeAriaLabel: copy.fileRemove(file.name)
  } : {}} size={size} data-sentry-element="AiBuilderAttachmentPreviewCard" data-sentry-component="AiBuilderFilePreviewCard" data-sentry-source-file="AiBuilderFilePreviewCard.tsx">
      {imageSrc ? <img src={imageSrc} alt="" className="size-full object-cover" /> : <AiBuilderAttachmentExtensionIcon extension={extension} className="size-8" />}
    </AiBuilderAttachmentPreviewCard>;
};